var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2550_8747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7649 1.25287C16.5877 1.25287 17.4025 1.41493 18.1626 1.7298C18.9228 2.04467 19.6135 2.50618 20.1953 3.08798C20.7771 3.66978 21.2386 4.36048 21.5535 5.12064C21.8684 5.88081 22.0304 6.69554 22.0304 7.51834V15.0369C22.0304 16.6986 21.3703 18.2922 20.1953 19.4672C19.0203 20.6423 17.4267 21.3024 15.7649 21.3024C14.1032 21.3024 12.5096 20.6423 11.3346 19.4672C10.1596 18.2922 9.49948 16.6986 9.49948 15.0369V7.51834C9.49948 5.85663 10.1596 4.26298 11.3346 3.08798C12.5096 1.91298 14.1032 1.25287 15.7649 1.25287ZM3.47461 17.4955L5.93318 17.003C6.38979 19.2742 7.61863 21.3172 9.4109 22.785C11.2032 24.2528 13.4483 25.0548 15.7649 25.0548C18.0816 25.0548 20.3267 24.2528 22.119 22.785C23.9113 21.3172 25.1401 19.2742 25.5967 17.003L28.0553 17.4955C26.9125 23.2384 21.8425 27.5678 15.7649 27.5678C9.68745 27.5678 4.61743 23.2384 3.47461 17.4955Z",
    fill: "#C3C3C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2550_8747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.0742,
    height: 30.0742,
    fill: "white",
    transform: "translate(0.728516)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoice);
export default __webpack_public_path__ + "static/media/voice.1e195c09fca6e9450b4792f1743d9a23.svg";
export { ForwardRef as ReactComponent };